import Choices from "choices.js"

const initChoices = (container = document) => {
  // Single
  container.querySelectorAll('select.choices').forEach((el) => {
    if (!el.dataset.choicesInitialized) {
      new Choices(el, {
        removeItemButton: true,
        placeholder: "Selecione",
        searchEnabled: true,
        shouldSort: true,
        searchPlaceholderValue: "Buscar",
        itemSelectText: '',
        noResultsText: '',
        noChoicesText: ''
      })
      el.dataset.choicesInitialized = "true"
    }
  })

  // Multi
  container.querySelectorAll('select.choices-multi').forEach((el) => {
    if (!el.dataset.choicesInitialized) {
      new Choices(el, {
        removeItemButton: true,
        placeholder: false,
        searchEnabled: true,
        shouldSort: true,
        searchPlaceholderValue: '',
        itemSelectText: '',
        noResultsText: '',
        noChoicesText: ''
      })
      el.dataset.choicesInitialized = "true"
    }
  })
}

// Inicializa na primeira carga da página e em qualquer turbo:load
document.addEventListener('turbo:load', () => {
  initChoices()
})

// Se você tiver Turbo Frames e quiser inicializar apenas dentro do frame que mudou:
document.addEventListener('turbo:frame-load', (event) => {
  initChoices(event.target)
})

window.initChoices = initChoices;